import copyToClipboard from 'copy-to-clipboard';

export const copyPieceURL = id => {
  return copyToClipboard(`${window.location.origin}/piece/${id}`);
};
